/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails>): BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails(), model);
        BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails>): BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.newInstance(<BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
